/**!
 * Created by Leonardo Cheslacki on 15/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import HelpersController from './helpers/HelpersController';

import Big from 'big.js';

let _this = {};

/**
 *
 */
class AnimateController extends HelpersController {
    /**
     *
     */
    constructor() {
        super();

        this.state = {
            disabled: false,
            element: null
        };

        _this = this;
    };

    $functionsAnimate = {
        /**
         *
         * @param event
         * @param uri
         * @param btn_action
         */
        handleRedirect: function (event, {uri, btn_action}) {
            const
                {disabled} = _this.state,
                {clicked} = btn_action.state;

            // if (disabled) { //provisional
            //     return _this.stopPropagation(event);
            // } else {
            //     _this.stopPropagation(event);
            // }

            // if (!clicked) {
                _this.setState({..._this.state, disabled: true});

                _this.setStateOccurrence(btn_action, {clicked: true});

                _this.inObject(btn_action, 'occ_pseudo_effect') && btn_action.occ_pseudo_effect.gotoAndPlay('start');

                !_this.isEmpty(uri) && _this.main.redirectRoute(`${_this.$root_uri}/${uri}`);
            // }
        },

        /**
         *
         * @param track
         * @returns {(function(): void)|*}
         */
        handlePlayAudio: (track) => function () {
            _this.readAudioSay(track, true);
        },

        /**
         *
         * @param event
         * @param callback
         */
        handleEndAudio: function (event, {callback}) {
            _this.setState({..._this.state, disabled: false}, ({element}) => {
                _this.isElement(element, 'audio') && element.pause();
                (typeof (callback) === 'function') && callback('ended');
            });
        },

        /**
         *
         * @param event
         * @param callback
         */
        handleEndVideo: function (event, {callback}) {
            _this.setState({..._this.state, disabled: false}, ({element}) => {
                _this.isElement(element, 'video') && element.pause();
                (typeof (callback) === 'function') && callback('ended');
            });
        }
    };

    /**
     *
     * @returns {*}
     */
    get = () => {
        const {current_name} = this.props;

        return this.main.getState(`_this_${current_name}`);
    };

    /**
     *
     * @returns {*}
     */
    getComposition = () => {
        const {current_name} = this.props;

        return this.main.getState(`composition._this_${current_name}`);
    };

    /**
     *
     * @returns {string}
     */
    occurrence = () => {
        const {currentFrame} = this.get();

        return this.padWithLeadingZeros(currentFrame, 2);
    };

    /**
     *
     * @param occurrence
     * @returns {string|*}
     */
    getFrame = (occurrence = null) => {
        if (this.isObjectIf(occurrence)) {
            const {currentFrame} = occurrence;

            return occurrence[`occ_frame_${this.padWithLeadingZeros(currentFrame, 2)}`];
        } else {
            return this.getObject(this.get(), `occ_frame_${this.occurrence()}`);
        }
    };

    /**
     *
     * @param _this_current
     * @param frame
     */
    gotoAndStopFrame = (_this_current, frame) => {
        _this_current.gotoAndStop(`frame${this.padWithLeadingZeros(frame, 2)}`);
    };

    /**
     *
     * @param occurrence
     * @param state
     * @param callback
     */
    setStateOccurrence = (occurrence, state, callback) => {
        !this.inObject(occurrence, 'state') && (occurrence.state = {});
        occurrence.state = {...occurrence.state, ...state};
        (typeof (callback) === 'function') && callback(true);
    };


    /**
     *
     * @param occurrence
     * @param width
     * @param height
     */
    addAvatar = (occurrence, width = 200, height = 200) => {
        const
            {data} = this.state,
            {occ_avatar: {occ_image}} = occurrence,
            formatted_uri = _this.verifyField(data, 'profile.avatar.formatted_uri');

        this.isArrayIf(occ_image.children) && (occ_image.children = []);

        let bitmap = (new createjs.Bitmap(formatted_uri));
        bitmap.image.onload = () => {
            bitmap.scaleX = this.calcSize(bitmap.image.width, width, bitmap.scaleX);
            bitmap.scaleY = this.calcSize(bitmap.image.height, height, bitmap.scaleY);
            occ_image.addChild(bitmap);
        };
    };

    /**
     *
     * @param occurrence
     * @param data
     */
    addImage = (occurrence, data) => {
        const
            {occ_menu, occ_menu: {occ_image}} = occurrence,
            formatted_uri = _this.verifyField(data, 'formatted_uri');

        this.isArrayIf(occ_image.children) && (occ_image.children = []);

        let bitmap = (new createjs.Bitmap(formatted_uri));
        bitmap.image.onload = () => {
            bitmap.scaleX = this.calcSize(bitmap.image.width, occ_menu.nominalBounds.width, bitmap.scaleX);
            bitmap.scaleY = this.calcSize(bitmap.image.height, occ_menu.nominalBounds.height, bitmap.scaleY);
            occ_image.addChild(bitmap);
        };
    };

    /**
     *
     * @param property
     */
    setAction = (property) => {
        const _this_frame = this.getFrame();

        let
            {occ, uri, field, stage} = property,
            object = null;

        if (!this.isEmpty(stage)) {
            object = this.get();
        } else if (!this.isEmpty(field)) {
            object = this.verifyField(_this_frame, field);
        } else {
            object = _this_frame;
        }

        let
            btn_action = object[`btn_${occ}`],
            className = this.toClassName(occ);

        this.setStateOccurrence(btn_action, {clicked: false});

        this[`_handleRedirect${className}`] && btn_action.off('mousedown', this[`_handleRedirect${className}`]);
        this[`_handleRedirect${className}`] = btn_action.on('mousedown', this.$functionsAnimate.handleRedirect, false, false, {
            uri: uri,
            btn_action: btn_action
        });
    };

    /**
     *
     * @param buttons
     */
    setActions = (buttons) => {
        for (let property of buttons) {
            this.setAction(property);
        }
    };

    setNavbar = () => {
        const
            {button_navbar} = this.props,
            {occ_menu} = this.getFrame();

        this.addAvatar(occ_menu);

        this.setActions(button_navbar);
    };

    /**
     *
     * @param _this_current
     * @param occurrence
     * @param callback
     */
    effectFadeIn = (_this_current, occurrence, callback = null) => {
        const
            {alpha_min, alpha_plus, alpha_max} = this.$controller,
            plus = (new Big(alpha_plus)),
            max = (new Big(alpha_max));

        let big_alpha_min = (new Big(alpha_min)).toNumber();

        if (this.isArrayIf(occurrence)) {
            for (let key in occurrence) {
                let occ = _this_current[occurrence[key]];
                !occ.isVisible() && (occ.visible = true);
                occ.alpha = big_alpha_min;
            }
        } else {
            let occ = _this_current[occurrence];
            !occ.isVisible() && (occ.visible = true);
            occ.alpha = big_alpha_min;
        }

        const execute = () => {
            let
                occ = this.isArrayIf(occurrence) ? _this_current[this.firstArray(occurrence)] : _this_current[occurrence],
                alpha = (new Big(occ.alpha)).plus(plus).round(1, Big.roundUp);

            if (this.isArrayIf(occurrence)) {
                for (let key in occurrence) {
                    _this_current[occurrence[key]].alpha = alpha.toNumber();
                }
            } else {
                _this_current[occurrence].alpha = alpha.toNumber();
            }

            if (alpha.gte(max)) {
                _this_current.removeEventListener('tick', execute);
                (typeof (callback) === 'function') && callback(true);
            }
        };

        _this_current.addEventListener('tick', execute);
    };

    /**
     *
     * @param _this_current
     * @param occurrence
     * @param callback
     */
    effectFadeOut = (_this_current, occurrence, callback = null) => {
        const
            {alpha_min, alpha_plus, alpha_max} = this.$controller,
            plus = (new Big(alpha_plus)),
            min = (new Big(alpha_min));

        if (this.isArrayIf(occurrence)) {
            for (let key in occurrence) {
                let occ = _this_current[occurrence[key]];
                occ.isVisible() && (_this_current[occurrence[key]].alpha = (new Big(alpha_max)).toNumber());
            }
        } else {
            let occ = _this_current[occurrence];
            occ.isVisible() && (_this_current[occurrence].alpha = (new Big(alpha_max)).toNumber());
        }

        const execute = () => {
            let
                occ = this.isArrayIf(occurrence) ? _this_current[this.firstArray(occurrence)] : _this_current[occurrence],
                alpha = (new Big(occ.alpha)).minus(plus).round(1, Big.roundUp);

            if (this.isArrayIf(occurrence)) {
                for (let key in occurrence) {
                    _this_current[occurrence[key]].alpha = alpha.toNumber();
                }
            } else {
                _this_current[occurrence].alpha = alpha.toNumber();
            }

            if (alpha.lte(min)) {
                if (this.isArrayIf(occurrence)) {
                    for (let key in occurrence) {
                        let occ = _this_current[occurrence[key]];
                        occ.isVisible() && (occ.visible = false);
                    }
                } else {
                    let occ = _this_current[occurrence];
                    occ.isVisible() && (occ.visible = false);
                }

                _this_current.removeEventListener('tick', execute);
                (typeof (callback) === 'function') && callback(true);
            }
        };

        _this_current.addEventListener('tick', execute);
    };

    /**
     *
     * @param uri
     * @param callback
     */
    readAudio = (uri, callback) => {
        const {disabled} = this.state;

        if (!disabled) {
            this.setState({...this.state, element: document.createElement('audio'), disabled: true}, ({element}) => {
                this.removeListener('ended', `ended-audio`, this.$functionsAnimate.handleEndAudio, () => {
                    this.addListener(element, 'ended', `ended-audio`, this.$functionsAnimate.handleEndAudio, false, {
                        callback: callback
                    });
                });

                element.src = uri;
                element.play();
            });
        }
    };

    /**
     *
     * @param track
     * @param animate
     * @param callback
     */
    readAudioSay = (track, animate = false, callback) => {
        const formatted_say_uri = this.verifyField(track, 'formatted_say_uri');

        if (formatted_say_uri) {
            if (animate) {
                const occ_icon_audio = this.verifyField(this.getFrame(), 'occ_title.occ_icon_audio') || this.verifyField(this.getFrame(), `occ_title.occ_icon_audio_${this.occurrence()}`);
                if (occ_icon_audio) {
                    occ_icon_audio.gotoAndPlay('start');
                    this.readAudio(formatted_say_uri, (response) => {
                        occ_icon_audio.gotoAndStop('start');
                        (typeof (callback) === 'function') && callback(response);
                    });
                } else {
                    this.readAudio(formatted_say_uri, callback);
                }
            } else {
                this.readAudio(formatted_say_uri, callback);
            }
        } else {
            (typeof (callback) === 'function') && callback('no-say');
        }
    };

    /**
     *
     * @param uri
     * @param callback
     */
    readVideo = (uri, callback) => {
        const {disabled} = this.state;

        if (!disabled) {
            this.setState({...this.state, element: document.createElement('video'), disabled: true}, ({element}) => {
                this.removeListener('ended', `ended-video`, this.$functionsAnimate.handleEndVideo, () => {
                    this.addListener(element, 'ended', `ended-video`, this.$functionsAnimate.handleEndVideo, false, {
                        callback: callback
                    });
                });

                element.src = uri;
                element.play();
            });
        }
    };

    /**
     *
     * @param track
     * @param animate
     * @param callback
     */
    readVideoMovie = (track, animate = false, callback) => {
        const formatted_path = this.verifyField(track, 'formatted_path');

        if (formatted_path) {
            if (animate) {
                const occ_icon_video = this.verifyField(this.getFrame(), 'occ_title.occ_icon_video');
                if (occ_icon_video) {
                    occ_icon_video.gotoAndPlay('start');
                    this.readVideo(formatted_path, (response) => {
                        occ_icon_video.gotoAndStop('start');
                        (typeof (callback) === 'function') && callback(response);
                    });
                } else {
                    this.readVideo(formatted_path, callback);
                }
            } else {
                this.readVideo(formatted_path, callback);
            }
        } else {
            (typeof (callback) === 'function') && callback('no-movie');
        }
    };
}

export default AnimateController;
